import React from 'react'
import type { RegistrationState } from 'lib-core'
import {
  RegistrationContextProvider,
  LoginForm,
  RegistrationForm,
  PhoneOtpForm,
  ConfirmationCode,
  ForgotPassword,
  ChangePassword,
} from 'lib-core'

// The canonical lib-core auth suite (login / register / phone OTP / verify /
// forgot password), replacing the old redux-form + MUI page bodies. The
// redux-first-router routes stay; each page mounts this with its initial
// panel state — the panel then manages sub-states via the location hash
// (#?state=...), which redux-first-router ignores (it matches on pathname).
export const AuthPanel = ({ initialState }: { initialState?: RegistrationState }) => {
  // NOTE: deliberately NOT calling useSetOnLoginUrl() here — that would
  // capture the login page itself as the post-login return URL. With no
  // captured URL the suite navigates home ("/") after a successful login,
  // matching the old redux-form pages' behavior.

  // initialState is a prop, not a hash write: assigning window.location.hash
  // here was invisible to the provider (react-router v5 never sees a
  // programmatic hash change), so every page but /login rendered the login
  // form. The provider still lets a hash state win, so emailed deep links
  // (#?state=verify&pin=... / #?state=change-password&token=...) keep working.
  return (
    <RegistrationContextProvider initialState={initialState}>
      {/* "ns" opts the subtree out of the legacy global button styles
          (components/Button.css) that force display:inline-block and would
          break the panel's flex buttons (spinner + label wrap and clip) */}
      <div className="ns flex items-start justify-center py-8 px-2">
        <LoginForm />
        <RegistrationForm />
        <PhoneOtpForm />
        <ConfirmationCode />
        <ForgotPassword />
        <ChangePassword />
      </div>
    </RegistrationContextProvider>
  )
}

export default AuthPanel
